import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const focusSlider = () => {
    const focusSliders = document.querySelectorAll('.focus-slider--block');

    if (!focusSliders.length) return;

    focusSliders.forEach(slider => {
        // Check if the slider element is valid and has the required structure
        if (!slider || !slider.querySelector('.swiper-wrapper')) return;

        // Calculate width adjustments
        // const viewportWidth = window.innerWidth;
        // console.log(viewportWidth);
        // const blockWidth = slider.offsetWidth;
        // console.log(blockWidth);
        // const blockStyle = window.getComputedStyle(slider);
        // const blockPadding = parseInt(blockStyle.paddingLeft) + parseInt(blockStyle.paddingRight);
        // const adjustedBlockWidth = blockWidth + blockPadding;
        // const slidesContainer = slider.querySelector('.focus-slider--slides');

        // if (slidesContainer) {
        //     const slidesWidth = slidesContainer.offsetWidth;
        //     console.log(slidesWidth);
        //     const widthDifference = viewportWidth - adjustedBlockWidth;
        //     console.log(widthDifference);
        //     const adjustment = widthDifference / 2;
        //     console.log(adjustment);

        //     // Add adjustment to width and push with margin
        //     slidesContainer.style.width = `${slidesWidth + adjustment}px`;
        //     slidesContainer.style.marginRight = `-${adjustment}px`;
        // }

        const swiper = new Swiper('.focus-slider--block .swiper', {
            slidesPerView: 1.25,
            spaceBetween: 26,
            loop: false,
            observer: true,
            observeParents: true,
            slidesPerGroupSkip: 1,
            pagination: {
                el: '.focus-slider--pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.focus-slider--button-next',
                prevEl: '.focus-slider--button-prev',
            },
            breakpoints: {
                1280: {
                    slidesPerView: 2.25,
                    spaceBetween: 50
                }
            }
        });
    });
}